import { render, staticRenderFns } from "./folders-option-file.vue?vue&type=template&id=80b322e0&scoped=true"
import script from "./folders-option-file.vue?vue&type=script&lang=js"
export * from "./folders-option-file.vue?vue&type=script&lang=js"
import style0 from "./folders-option-file.vue?vue&type=style&index=0&id=80b322e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b322e0",
  null
  
)

export default component.exports